import React from "react";

const Spinner = () => (
  <div className="spinner__container">
    <div className="spinner__content">
      <svg className="spinner__circular" viewBox="25 25 50 50">
        <circle
          className="spinner__circular__background"
          cx="50"
          cy="50"
          r="20"
          fill="none"
        />
        <circle
          className="spinner__circular__foreground"
          cx="50"
          cy="50"
          r="20"
          fill="none"
        />
      </svg>
    </div>
  </div>
);

export default Spinner;
